module.exports = __webpack_public_path__ + "img/pickup_truck.28af93e7.png";